module.exports = __webpack_public_path__ + "img/background-main-mobile-act.071778c9.svg";